import { TFunction } from 'react-i18next';

export const TABS = {
  scheduled: 'scheduled',
  logged: 'logged',
};

export const defaultScheduledColumnSettings = {
  columns: [
    {
      id: 'employee',
      label: 'Assignee',
      localizedLabel: (t: TFunction) => t('Assignee'),
      order: 1,
      visible: true,
      related: false,
    },
    {
      id: 'dueDateMyTime',
      label: 'Due Date (My Time)',
      localizedLabel: (t: TFunction) => t('Due Date (My Time)'),
      order: 2,
      visible: true,
      related: false,
    },
    {
      id: 'client',
      label: 'Contact',
      localizedLabel: (t: TFunction) => t('Contact'),
      order: 3,
      visible: true,
      related: true,
    },
    {
      id: 'dueDateBusinessTime',
      label: 'Due Date (Business Time)',
      localizedLabel: (t: TFunction) => t('Due Date (Business Time)'),
      order: 4,
      visible: false,
      related: false,
    },
    {
      id: 'created',
      label: 'Created',
      localizedLabel: (t: TFunction) => t('Created'),
      order: 5,
      visible: false,
      related: false,
    },
    {
      id: 'originalDueDatetime',
      label: 'Original Due Date',
      localizedLabel: (t: TFunction) => t('Original Due Date'),
      order: 6,
      visible: false,
      related: false,
    },
  ],
  sort: {
    column: 'due_datetime_my_time',
    direction: 'asc',
  },
};

export const defaultLoggedColumnSettings = {
  columns: [
    {
      id: 'loggedAt',
      label: 'Logged At',
      localizedLabel: (t: TFunction) => t('Logged At'),
      order: 1,
      visible: true,
      related: false,
    },
    {
      id: 'loggedBy',
      label: 'Logged By',
      localizedLabel: (t: TFunction) => t('Logged By'),
      order: 2,
      visible: true,
      related: false,
    },
    {
      id: 'scheduledOn',
      label: 'Scheduled On',
      localizedLabel: (t: TFunction) => t('Scheduled On'),
      order: 3,
      visible: true,
      related: false,
    },
    {
      id: 'originalDueDatetime',
      label: 'Original Due Date',
      localizedLabel: (t: TFunction) => t('Original Due Date'),
      order: 4,
      visible: false,
      related: false,
    },
    {
      id: 'client',
      label: 'Contact',
      localizedLabel: (t: TFunction) => t('Contact'),
      order: 5,
      visible: true,
      related: true,
    },
  ],
  sort: {
    column: 'logged_at',
    direction: 'asc',
  },
};

export const defaultScheduledPageSettings = {
  page_size: 25,
  search: '',
};

export const defaultLoggedPageSettings = {
  page_size: 25,
  search: '',
};
